import axios from 'src/utils/axios';

export default function v2_actionVincularContatosLista(contato_ids, lista_id) {
    return axios.put('/api/v2/cadastro/contatos/vincular-lista', { contato_ids, lista_id });
}
